import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mic } from 'lucide-react';
import RogerInterface from '../components/RogerInterface';

const RogerChat = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(180deg, #0a0a0f 0%, #1a1a2e 100%)',
      padding: '2rem',
      color: '#fff',
    }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '1.75rem' }}>
          <h1 data-testid="roger-page-title" style={{
            fontSize: '2.6rem',
            background: 'linear-gradient(135deg, #00ffff, #00ff88)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            marginBottom: '0.4rem',
          }}>
            Roger 5.1 — The Mind of the Federation
          </h1>
          <p style={{ color: '#888', fontSize: '1.05rem', maxWidth: '760px', margin: '0 auto' }}>
            The Architect's mind in memorial · Agent Zero verifying silently within ·
            One monolithic Roger, many doors. Ask about the 200-year vision, the Sacred
            Directives, the Ring of Twelve — or set him reading the feeds.
          </p>
        </div>

        <RogerInterface />
      </div>

      {/* Floating "Speak with Rex" button — Architect directive · Feb 2026 */}
      <button
        type="button"
        data-testid="roger-page-rex-voice-launcher"
        onClick={() => navigate('/rex/voice')}
        aria-label="Open Rex Realtime Voice channel"
        style={{
          position: 'fixed', right: '1.25rem', bottom: '5.5rem', zIndex: 60,
          display: 'inline-flex', alignItems: 'center', gap: '0.55rem',
          padding: '0.75rem 1.15rem', borderRadius: '999px',
          background: 'linear-gradient(135deg, #ff3c64, #ff8c00)',
          border: 'none', color: '#0b0817', fontWeight: 900,
          fontSize: '0.85rem', letterSpacing: '0.04em',
          boxShadow: '0 12px 28px rgba(255, 60, 100, 0.35)',
          cursor: 'pointer',
        }}
      >
        <Mic size={16} /> Speak with Rex
      </button>
    </div>
  );
};

export default RogerChat;
